import { useContext, useEffect, useCallback } from "react";
import sadDogImg from "../../assets/img/abandoned-little-corgi-tears-on-600nw-782268976 1.jpg";
import { useNavigate } from "react-router-dom";
import { AdminContext } from "../../context/AdminContext";

const AdminLogout = () => {
  const navigate = useNavigate();
  const { showLogoutModal, handleCloseModal } = useContext(AdminContext);

  const handelLogout = useCallback(() => {
    try {
      localStorage.removeItem("admin");
      localStorage.removeItem("adminToken");
      window.dispatchEvent(new Event("storage"));
      handleCloseModal();
      navigate("/adminLogin");
    } catch (error) {
      console.error("Logout error:", error);
    }
  }, [handleCloseModal, navigate]);

  const handleKeyDown = useCallback((event) => {
    if (event.key === "Escape") {
      handleCloseModal();
    }
  }, [handleCloseModal]);

  useEffect(() => {
    if (!showLogoutModal) return;
    
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showLogoutModal, handleKeyDown]);

  if (!showLogoutModal) {
    return null;
  }
  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content logoutpopup p-4 rounded-4 text-center">
            <button
              type="button"
              className="btn-close ms-auto"
              onClick={handleCloseModal}
              aria-label="Close"
            ></button>
            <img src={sadDogImg} alt="Sad Dog" className="mx-auto mb-4" />
            <h5 className="fw-600 ft-20 mb-2">
              Are you sure you want to Logout?
            </h5>
            <p className="text-muted ft-16 fw-400">
              Lorem Ipsum is simply dummy text of the printing & typesetting
              industry.
            </p>
            <div className="d-flex justify-content-center gap-3 mt-5">
              <button
                type="button"
                className="btn btn-outline-dark preview_survey rounded-3 ft-15 w-100"
                onClick={handleCloseModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-dark create_survey rounded-3 ft-15 w-100"
                onClick={handelLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AdminLogout;
